import axios from "axios"
import { Upload, Button, Modal, Spin } from "antd"
import { UploadOutlined } from "@ant-design/icons"
import { warning } from "../../../helpers"
import { useContext, useState, useEffect } from "react"
import PropTypes from "prop-types"
import { PageContext } from "../../../contexts"
import { getDocumentAws, setDocument, DeleteDocumentAws } from "../../../helpers"
import { useAuth } from "../../../contexts/auth"
import { useMutation } from "@apollo/client"
import { createDownloadLog } from "../../../graphql/submission/mutations/createDownloadLog"

UploadButtonForm.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onRemoveFile: PropTypes.func,
  fileList: PropTypes.arrayOf(PropTypes.object),
  maxFile: PropTypes.number,
  accept: PropTypes.string,
  setParentLoading: PropTypes.func,
  customNameGenerator: PropTypes.func
}

export function UploadButtonForm ({
  children,
  style,
  disabled = false,
  onChange,
  onRemoveFile,
  fileList = [],
  maxFile = 1,
  accept,
  customNameGenerator,
  blocked,
  OldDocuments,
  setParentLoading,
  key=null,
  exportData = true,
  isFacture,
  isStatements,
  deferDelete = false,
}) {

  const [loading, setLoading] = useState(false)
  const isDisabled = loading || disabled || fileList?.length >= maxFile
  const [state, setState] = useState({ fileList, disabled: isDisabled })
  const [uploading, setUploading] = useState(false) 

  const onUploadChange = async (Archivo, status) => {
  
  setState(prev => {
    const newFileList = [...prev.fileList, Archivo].slice(-maxFile);

    if (status === "done") {
      if (isFacture) {
        isFacture([...newFileList])
      }

      if (isStatements) {
        isStatements([...newFileList])
      }
      onChange && onChange(newFileList)
      setLoading(false)
      setParentLoading && setParentLoading(false)
    } else if (status === "error") {
      warning("Ha ocurrido un error al subir el archivo, inténtalo de nuevo en unos segundos.");
    } else if (status === "uploading") {
      setLoading(true);
      setParentLoading && setParentLoading(true);
    }

    return {
      fileList: newFileList,
      disabled: newFileList.length >= maxFile
    }
  })
}
  const onDeleteFileChange = async (Archivo) => {
    let fileList = [...state.fileList]
    
    const newFiles = fileList.filter(document => document.url !== Archivo.url)
    
    setState({...state, fileList: newFiles,  disabled: newFiles.length >= maxFile })
    
  }

  const { userPermissions } = useContext(PageContext)
  const userCanExportData = (userPermissions || {})?.GLOBAL?.EXPORT_DATA

  const notDownloadableFiles = (files) => (files || []).map(file => {
    // eslint-disable-next-line no-unused-vars
    const { url, ...f } = file
    return f
  })


  const uploadFileToS3 = async (file) => {
    
    try {
      
      if (!(file instanceof Blob)) {
        throw new Error("El archivo no es un Blob válido");
      }
      
      const response = await setDocument(file)
        
      onUploadChange(response, "done")
      setUploading(false)
      return response;
    } catch (e) {
      console.error(e);
      setUploading(false)
      return null;
    }
  };

  const auth = useAuth()
  const userAuthDownload = auth?.user?.claims ?? {}

  /** Function to register data of downloaded documents **/

  const handleDownload = ( file ) => {

    getDocumentAws(file.url)

    if (!userAuthDownload) {
      console.error("No user information available")
      return
    }

    const downloadInfo = {
      email: userAuthDownload.email,
      userName: userAuthDownload.name,
      role: userAuthDownload.role,
      uid: userAuthDownload.user_id,
      documentName: file.name,
      type: file.type
    }

    trackDownload({
      variables: { data: downloadInfo }
    })
      .catch((error) => {
        console.error(error)
      })

  }

  const [trackDownload] = useMutation(createDownloadLog)

  if(OldDocuments){
    return (
      <Upload 
        style={style}
        fileList={userCanExportData && exportData
          ? state.fileList
          : notDownloadableFiles(state.fileList)}
        onChange={onUploadChange}
        onRemove={file => {
          const { confirm } = Modal
          return new Promise(resolve => {
            confirm({
              width: 500,
              title: `Estás seguro de eliminar ${file.name}?`,
              content: "Si lo eliminas, no podrás recuperarlo.",
              onOk: async () => {
                if (!deferDelete) {
                  const ok = await DeleteDocumentAws(file)
                  if (!ok) { resolve(false); return warning("Ha ocurrido un error al intentar eliminar el archivo.") }
                }
                onRemoveFile && onRemoveFile(file)
                onDeleteFileChange(file)
                resolve(true)
              }
            })
          })
        }}
        accept={accept}
        onPreview={(file) => {
          handleDownload(file)
        }}
        showUploadList={{
          showRemoveIcon: !disabled,
          itemRender: (originNode, file) => (
            <div
          // style={{ cursor: "pointer", color: "#80587e" }}
            onClick={(event) => {
            event.preventDefault()
            handleDownload(file)
          }} 
        >
          {file.name}
        </div>
          ),
        }}
        multiple>
      </Upload>
    )
  }

  return (
    <>
    <Upload
      key={key}
      style={style}
      fileList={userCanExportData
        ? state.fileList
        : notDownloadableFiles(state.fileList)}
      beforeUpload={async (file) => {
        setLoading(true)
        setUploading(true)
        setParentLoading && setParentLoading(true)

        const uploadedFile = await uploadFileToS3(file);

        if (!uploadedFile) return false;
        return false
      }}
      onRemove={file => {
        const { confirm } = Modal
      
        return new Promise(resolve => {
          confirm({
            width: 500,
            title: `¿Estás seguro de quitar ${file.name}?`,
            content: "El archivo se eliminará hasta guardar los cambios.",
            onOk: () => {
              onRemoveFile && onRemoveFile(file)
              onDeleteFileChange(file)
              resolve(true)
            },
            onCancel: () => resolve(false)
          })
        })
      }}
      accept={accept}
      onPreview={(file) => {
        handleDownload(file)
      }}
      showUploadList={{
        showRemoveIcon: !disabled,
        itemRender: (originNode, file) => (
          <div
          // style={{ cursor: "pointer", color: "#80587e" }}
          onClick={(event) => {
          event.preventDefault(); 
           handleDownload(file);
           }}
        >
          {file.name}
        </div>
        ),
      }}
      multiple>
      <Button 
        disabled={blocked || state.disabled}>
        <UploadOutlined
        /> {children}
      </Button>
    </Upload>

    {uploading && 
     <div className="project-loading">
          <Spin tip="Subiendo Archivo"/>
      </div>
    }
    </>
  )
}
